// React Imports
import React, { Component } from "react";
import PropTypes from 'prop-types';

// My Imports
import Header from "../components/Header";
import Footer from "../components/Footer";

// Styles
import "./assets/animate.css";
import "./assets/animatedresponsiveImagegrid.css";
import "./assets/bootstrap.css";
import "./assets/icomoon.css";
import "./assets/magnific-popup.css";
import "./assets/owl.carousel.min.css";
import "./assets/owl.theme.default.min.css";
import "./assets/style.css";

export default class CoreLayout extends Component {
    render() {
        return <div className="layout">
                <Header/>
            <div className="content">
                   {this.props.children}
            </div>
                <Footer/>
        </div>;
    }
}

CoreLayout.propTypes = {
    children: PropTypes.element.isRequired
};


/** WEBPACK FOOTER **
 ** ./src/layouts/CoreLayout.js
 **/